import React from 'react';
import { useWidget } from './useWidget';
import { Button, Card, Divider, Space, Dropdown } from 'antd';
import NetworkAccountSelect from 'components/Selects/NetworkAccountSelect/NetworkAccountSelect';
import Icon from '@mdi/react';
import { mdiFloppy } from '@mdi/js';
import StatusSelect from 'components/Selects/StatusSelect';
import DateRangePicker from 'components/DateRangePicker';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';
import { useDashboardLayout } from 'store/redux/states/dashboard/dashboard.hooks';
import ShopifySelect from 'components/Selects/ShopifySelect';
import PropTypes from 'prop-types';

const WidgetFilter = (props) => {
  const {
    index,
    disableDateFilter,
    disableStatusFilter,
    disableShopifyFilter = false,
    disableAccountsFilter,
    default_filter,
  } = props;
  const { widget_key, filters, setFilters, runFilter } = useWidget();
  const { setDate, dates } = useWidgetDate(widget_key);
  const { config, updateWidget, isLoading } = useDashboardLayout();

  const updateDefaultFilter = () => {
    runFilter();
    const updatedConfig = [...config];

    const dateRange = dates.date_range_key
      ? { date_from: null, date_to: null, date_range_key: dates.date_range_key }
      : { ...dates };

    updatedConfig[index] = {
      ...updatedConfig[index],
      defaultFilter: { ...filters, ...dateRange },
    };
    updateWidget(updatedConfig);
  };

  const handleAccountFiltersChange = (account_ids) => {
    setFilters({
      ...filters,
      network_account_ids: account_ids,
    });
  };

  const handleStatusChange = (statuses) => {
    setFilters({
      ...filters,
      statuses: statuses,
    });
  };

  const handleShopifyFilter = (val) => {
    setFilters({
      ...filters,
      integration_ids: val,
    });
  };

  const resetFilter = () => {
    setFilters(default_filter);
    setDate({ date_from: default_filter.date_from, date_to: default_filter.date_to });
    runFilter();
  };

  return (
    <Card size='small' className='w-[400px]'>
      <Space direction='vertical' className='w-full'>
        <div className='grid grid-cols-2 gap-2'>
          {!disableDateFilter ? (
            <div className='col-span-2 md:col-span-1'>
              <DateRangePicker
                variant='input'
                date_key={widget_key}
                defaultValue={{
                  date_range_key:filters.date_range_key,
                  date_from: filters.date_from,
                  date_to: filters.date_to,
                }}
              />
            </div>
          ) : null}
          {!disableStatusFilter ? (
            <div className='col-span-2 md:col-span-1'>
              <StatusSelect value={filters.statuses} onChange={handleStatusChange} />
            </div>
          ) : null}
        </div>

        {!disableAccountsFilter ? (
          <NetworkAccountSelect
            value={filters.network_account_ids}
            onChange={handleAccountFiltersChange}
            maxTagCount={10}
          />
        ) : null}
        {disableShopifyFilter ? (
          <ShopifySelect onChange={handleShopifyFilter} value={filters.integration_ids || null} />
        ) : null}
        <Divider className='my-2' />
        <div className='flex justify-between'>
          <Button type='dashed' onClick={resetFilter}>
            Reset
          </Button>
          <Dropdown.Button
            onClick={runFilter}
            loading={isLoading}
            className='w-fit'
            menu={{
              items: [
                {
                  key: 'save',
                  label: 'Save',
                  loading: isLoading,
                  icon: <Icon path={mdiFloppy} />,
                  onClick: updateDefaultFilter,
                },
              ],
            }}
            type='primary'
          >
            Filter
          </Dropdown.Button>
        </div>
      </Space>
    </Card>
  );
};

WidgetFilter.propTypes = {
  disableDateFilter: PropTypes.bool,
  disableStatusFilter: PropTypes.bool,
  disableAccountsFilter: PropTypes.bool,
  index: PropTypes.number.isRequired,
  disableShopifyFilter: PropTypes.bool,
  default_filter: PropTypes.object,
};

export default WidgetFilter;
